// 日语
export default {
  page_home: {
    mock_tit: "英語の先生",
  },
};